module.exports = __webpack_public_path__ + "static/img/icon-part2-2.ab78e3c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icon-part2-2.png
// module id = Af+d
// module chunks = 1